//import "../../public/leegalityv6.js";
import React, { Component ,useState, useEffect} from "react";
import customFetch from "./apicall/api";
import { logout, generateId } from "./Utility";
import Webcam from "react-webcam";
import { ThemeContext } from "../context/IsLoader";
import { PEButton, PEDiv, PEImg, PEInput, PEA, PESpan } from "./permissionComponents";
import loader_styles from "../assets/css/md_loader.module.css";

// AT-1739 | AT-2199 | Ankur Makavana | 19-07-2023 | Enable back camera selection
const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
  facingMode: FACING_MODE_USER,
};
let intervalId;

const generate_Id1 = generateId(10);
var api_token = "";
class Insurance extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.state = {
      loan_id: "",
      isSpin: false,
      insuranceProducts: [],
      isErrOpen: false,
      api_error_message: "",
      loader_message: "",
      hasSearched: false
    };
  }
  componentDidMount() {
    document.title = "Insurance";
    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
  }
  getInsuranceProducts = (loan_id = "") => {
    if (loan_id === "") {
      loan_id = this.state.loan_id;
    }
    if (!loan_id) {
      this.setState({
        isErrOpen: true,
        api_error_message: "Please enter a Loan ID",
      });
      return;
    }

    this.setState({ isSpin: true, loader_message: "Fetching insurance products", hasSearched: true });

    let generate_Id = generateId(10);
    const url = process.env.REACT_APP_URL + "/insurance/products/list?loan_id=" + loan_id;

    customFetch(url, {
      method: "GET",
      headers: {
        "api-token": api_token,
        component_id: generate_Id1,
        apiId: generate_Id,
        api_group_id: "",
        component: this.constructor.name,
        user_id: localStorage.getItem("in_userid"),
      },
    })
      .then((res) => {
        if (res.status !== 200) {
          this.setState({
            isErrOpen: true,
            api_error_message: "Please Contact Technical Team.",
            isSpin: false,
          });
        }
        if (res.headers.get("api_code") > 0) {
          this.setState({
            isErrOpen: true,
            api_error_message: res.headers.get("api_error_message"),
            isSpin: false,
          });
        }
        return res.json();
      })
      .then((data) => {
        if (data.api_code === 4 || data.api_code === 3 || data.api_code === 5) {
          localStorage.clear();
          this.props.history.push("/");
        }
        if (data.message) {
          this.setState({
            isErrOpen: true,
            api_error_message: data.message,
            isSpin: false,
          });
        } else {
          this.setState({
            insuranceProducts: data.products || [],
            isSpin: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isSpin: false,
          isErrOpen: true,
          api_error_message: error.message || "An error occurred.",
        });
      });
  };
  handleInsuranceAction = async (product) => {
    if (product.status === "Paid") {
      // Do nothing for Paid status
      return;
    }

    this.setState({ isSpin: true, loader_message: "Checking status" });

    try {
      const statusResponse = await customFetch(
        process.env.REACT_APP_URL + "/insurance/policy/status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "api-token": api_token,
          },
          body: JSON.stringify({
            loan_documentation_id: product.loan_documentation_id,
          }),
        }
      );

      const statusData = await statusResponse.json();
      this.setState({ isSpin: false });

      if (statusResponse.status !== 200) {
        throw new Error(statusData.message || "Failed to get policy status.");
      }

      const policyStatus = statusData.data.policy_detail.policy_status;
      const eligibility = statusData.data.eligility;

      if (policyStatus === "A" || eligibility === false) {
        this.setState({
          isErrOpen: true,
          api_error_message: "Policy is already active or customer is not eligible.",
        });
      } else if (policyStatus === "T") {
        const encryptedProposalNum = statusData.data.policy_detail.encrypted_vendor_reference_id;
        const proposalNum = statusData.data.policy_detail.vendor_reference_id;
        const csrfToken = statusData.data.policy_detail.customer_reference_id;
        this.setState({
          isSpin: true,
        });
        this.initiateInsurancePayment(proposalNum, encryptedProposalNum, csrfToken);
        // this.setState({
        //   isSpin: false,
        // });
        setTimeout(() => this.getInsuranceProducts(), 1500);
      } else if (eligibility === true) {
        this.setState({
          isSpin: true,
          loader_message: "Creating policy",
        });
        const createResponse = await customFetch(
          process.env.REACT_APP_URL + "/insurance/policy/create",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "api-token": api_token,
            },
            body: JSON.stringify({
              loan_documentation_id: product.loan_documentation_id,
            }),
          }
        );

        const createData = await createResponse.json();

        if (createResponse.status !== 200) {
          throw new Error(createData.message || "Failed to create policy.");
        }
        if (createData.status === 1 && createData.vendor_reference_id) {
          this.initiateInsurancePayment(
            createData.vendor_reference_id,
            createData.encrypted_vendor_reference_id,
            createData.customer_reference_id
          );
          // this.setState({
          //   isSpin: false,
          // });
          setTimeout(() => this.getInsuranceProducts(), 1500);
        } else {
          throw new Error(
            createData.message ||
              "Policy creation did not return a vendor reference ID."
          );
        }
      }
    } catch (error) {
      this.setState({
        isSpin: false,
        isErrOpen: true,
        api_error_message: error.message || "Unable to process insurance action.",
      });
    }
  };
  initiateInsurancePayment = (proposalNum,encryptedProposalNum, csrfToken) => {
    const form = document.createElement("form");
    console.log("payment redirect url :",process.env.REACT_APP_CAREHEALTH_PAYMENT_URL)
    form.action = process.env.REACT_APP_CAREHEALTH_PAYMENT_URL || "https://apiuat.careinsurance.com/portalui/PortalPaymentV2.run";
    form.method = "post";
    form.id = "PAYMENTFORM";
    form.name = "PAYMENTFORM";
    form.target = "_blank"; 

    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "CSRF";
    csrfInput.value = csrfToken;

    const proposalNumInput = document.createElement("input");
    proposalNumInput.type = "hidden";
    proposalNumInput.name = "proposalNum";
    proposalNumInput.value = encryptedProposalNum;

    const sourceInput = document.createElement("input");
    sourceInput.type = "hidden";
    sourceInput.name = "source";
    sourceInput.value = "PARTNER";

    const returnURLInput = document.createElement("input");
    returnURLInput.type = "hidden";
    returnURLInput.name = "returnURL";

    const origin = window.location.origin;
    const pathname = this.props.location.pathname; 
    
    // const return_url =  `${origin}/paymentresponse/${proposalNum}`
    const return_url = process.env.REACT_APP_URL + `/insurance/payment-callback/${proposalNum}`
    console.log(return_url)
    // console.log("return url", return_url)
    returnURLInput.value = return_url;
    form.appendChild(csrfInput);
    form.appendChild(proposalNumInput);
    form.appendChild(sourceInput);
    form.appendChild(returnURLInput);

    document.body.appendChild(form);
    form.submit();
    // print the items in the for// print the items in the form
    // for (let i = 0; i < form.elements.length; i++) {
    //   const el = form.elements[i];
    //   console.log(`Form element: name="${el.name}", value="${el.value}"`);
    // }
    document.body.removeChild(form);
  };

  refreshPolicyStatus = async (product) => {
    this.setState({ isSpin: true, loader_message: "Refreshing status" });

    try {
      const statusResponse = await customFetch(
        process.env.REACT_APP_URL + "/insurance/policy/status",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "api-token": api_token,
          },
          body: JSON.stringify({
            loan_documentation_id: product.loan_documentation_id,
          }),
        }
      );

      const statusData = await statusResponse.json();

      if (statusResponse.status !== 200) {
        throw new Error(statusData.message || "Failed to refresh policy status.");
      }

      const policyStatus = statusData.data.policy_detail.policy_status;
      let displayStatus = "Pending"; // Default
      if (policyStatus === "A") {
          displayStatus = "Paid";
      } else if (policyStatus === "Z") {
          displayStatus = "Pending Proposal";
      } else if (policyStatus === "T") {
          displayStatus = "Pending Payment";
      }
      // Update the specific product with new status data
      const updatedProducts = this.state.insuranceProducts.map((prod) =>
        prod.loan_documentation_id === product.loan_documentation_id
          ? {
              ...prod,
              status: displayStatus,
              proposal_num: statusData.data.policy_detail.vendor_reference_id || prod.proposal_num,
              encrypted_proposal_num: statusData.data.policy_detail.encrypted_vendor_reference_id || prod.encrypted_proposal_num,
              csrf_token: statusData.data.policy_detail.customer_reference_id || prod.csrf_token,
              flag: statusData.data.policy_detail.policy_status,
            }
          : prod
      );

      this.setState({
        insuranceProducts: updatedProducts,
        isSpin: false,
        // isErrOpen: true,
        // api_error_message: "Policy status refreshed successfully.",
      });
    } catch (error) {
      this.setState({
        isSpin: false,
        isErrOpen: true,
        api_error_message: error.message || "Unable to refresh policy status.",
      });
    }
  };

  callback(response) {
    if (response.error) {
      console.log("callback error", response.error);
    } else {
      console.log("callback message", response.message);
    }
  }
  render() {
    return (
      <>
        <OverlayLoader isLoading={this.state.isSpin} message={this.state.loader_message} />

        <div className="container">
          <div
            className={
              this.state.isErrOpen
                ? "modal fade bd-example-modal-sm show mymodal"
                : "modal fade bd-example-modal-sm"
            }
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
            id="confirm-box"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content cdb-confirm-box col-sm-12">
                <button
                  type="button"
                  className="close text-right"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.setState({ isErrOpen: false })}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <p>{this.state.api_error_message}</p>
              </div>
            </div>
          </div>

          <div className="payload_view_navbar">
            <button
              className="button back_button"
              onClick={() => this.props.history.goBack()}
            >
              <img src={require("../assets/images/back.png")} alt="" />
            </button>
            <h4>Insurance</h4>
            <button className="button" onClick={() => logout(null, null, true)}>
              <img src={require("../assets/images/power-off.png")} alt="" />
            </button>
          </div>

          <div className="card-holdermain">
            <PEDiv element_id="InsuranceSearchLoanid" className="search-holder">
              <label className="search-label">Enter Loan ID</label>
              <div className="searchinput row">
                <div className="col-md-10 mt-1">
                  <input
                    className="form-control search-input"
                    name="loan_id"
                    value={this.state.loan_id}
                    onChange={(e) => this.setState({ loan_id: e.target.value, hasSearched: false })}
                  />
                </div>
                <div className="col-md-2 mt-1">
                  <button
                    className="search-btn"
                    onClick={() => this.getInsuranceProducts()}
                  >
                    Search
                  </button>
                </div>
              </div>
            </PEDiv>

            <div className="main-container mt-4">
              <main className="card-container">
                {this.state.insuranceProducts && this.state.insuranceProducts.length > 0 ? (
                  this.state.insuranceProducts.map((product, index) => (
                    <div className="insurance-card mt-3" key={index}>
                      <div className="card-content">
                        <div className="product-header">
                          <span className="product-label">Product - </span>
                          <span className="product-value">{product.product_name || "Insurance"}</span>
                        </div>

                        <div className="info-grid">
                          <div className="info-item">
                            <span className="insurancecardlabel">Insured Name:</span>
                            <span className="insurancecardname">{product.insured_name}</span>
                          </div>
                          <div className="info-item">
                            <span className="insurancecardlabel">Nominee Name:</span>
                            <span className="insurancecardname">{product.nominee_name}</span>
                          </div>
                          <div className="info-item">
                            <span className="insurancecardlabel">Amount to Pay:</span>
                            <span className="insurancecardname highlight-amt">₹ {product.amout_to_pay || "-"}</span>
                          </div>
                          <div className="info-item">
                            <span className="insurancecardlabel">Payment Status:</span>
                            <span className={`status-badge ${product.status.toLowerCase().includes('pending') ? 'pending' : product.status.toLowerCase()}`}>
                              {product.status}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="card-actions">
                        {product.status === "Paid" ? (
                          <button className="btn-status paid" disabled>Paid</button>
                        ) : (
                          <div className="action-buttons-group">
                            <button 
                              className="btn-status proceed" 
                              onClick={() => this.handleInsuranceAction(product)}
                            >
                              {/* {product.status.toLowerCase().includes('pending') ? 'Pay Now' : 'Proceed'} */}
                              Proceed
                            </button>
                            
                            <button 
                              // className="btn-status refresh-status" 
                              className="btn-refresh-icon" 
                              onClick={() => this.refreshPolicyStatus(product)}
                              title="Refresh Status"
                            >
                              &#8635;
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-data-card">
                    <p>{this.state.hasSearched ? "No insurance products found for this Loan ID" : "Enter a Loan ID and search to view insurance products"}
                    </p>
                  </div>
                )}
              </main>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function TextWithBr({ text }) {
  const lines = text.split('\n');
  return (
    <>
        {lines.map((line, index) => (
          <React.Fragment key={index}>
              {processAndHighlightExtraSpaces(line)}
              {/* {line} */}
              {index < lines.length - 1 && <br />}
          </React.Fragment>
        ))}
    </>
  );
}

export const processAndHighlightExtraSpaces = (lineText) => {
  if (typeof lineText !== 'string' || lineText === null) {
    return null;
  }

  
  const parts = lineText.split(/(\s+)/g).filter(part => part !== "");;
  // console.log("space parts:", parts);

  return (
    <>
      {parts.map((part, idx) => {
        if (part && /^\s+$/.test(part)) {
          if (part.length > 1) {
            const renderedSpaces = [];
            renderedSpaces.push(<React.Fragment key={`${idx}-normal`}> </React.Fragment>);
            for (let i = 0; i < part.length - 1; i++) {
              renderedSpaces.push(
                <h6 key={`${idx}-highlight-${i}`} className="extra-space-highlight">
                  {' '} 
                </h6>
              );
            }
            return <React.Fragment key={idx}>{renderedSpaces}</React.Fragment>;
          }else if(idx === parts.length - 1) {
            // If it's the last part and it's a single space, return a highlighted space
            // handle the case where the last part is a single space
            return <h6 key={`${idx}-highlight-${idx}`} className="extra-space-highlight">
              {' '} 
            </h6>
          } else {
            return <React.Fragment key={idx}> </React.Fragment>;
          }
        } else {
          return <React.Fragment key={idx}>{part}</React.Fragment>;
        }
      })}
    </>
  );
};
function LocalisedMessageBox({ message }) {
  const languages = Object.keys(message);

  const [currentLanguage, setCurrentLanguage] = useState(
    languages.find(lang => lang !== "English") || languages[0]
  );

  // Function to handle language change when a language link is clicked.
  const handleLanguageChange = (langCode) => {
    setCurrentLanguage(langCode);
  };

  // Get the current message based on the selected language.
  const displayMessage = message[currentLanguage];

  return (
    <>
      <div className="main-content-box">
        {/* Language Toggle Links */}
        <img className="error-alert-icon" src={require("../assets/images/alert.png")} alt="Language Icon" /> 
        <div className="language-toggle">
          {languages.map((lang, index) => (
            <React.Fragment key={lang}>
              <button
                className={currentLanguage === lang? 'active' : ''}
                onClick={() => handleLanguageChange(lang)}
              >
                {lang}
              </button>
            </React.Fragment>
          ))}
        </div>

        {/* Message Display Area */}
        <div className="message-display-area">
          <p>
            <TextWithBr text={displayMessage} />
          </p>
        </div>
      </div>
    </>
  );
}

export default Insurance;

const OverlayLoader = ({ isLoading, message}) => {
    // If not loading, return null to avoid rendering the component entirely.
    const [dots, setDots] = useState('');
    
    useEffect(() => {
        // if (!isLoading) {
        //     setDots('');
        //     return;
        // }
        const interval = setInterval(() => {
            setDots(prevDots => {
                switch (prevDots) {
                    case '.':
                        return '..';
                    case '..':
                        return '...';
                    case '...':
                    default:
                        return '.';
                }
            });
        }, 500);

        return () => clearInterval(interval);
    }, [isLoading]);
    
  if (!isLoading) return null;
  return (
    // Full-screen fixed container using the manually-scoped class
    <div
          className={loader_styles.backdrop}
          aria-modal="true"
          role="status"
      >
          {/* Loading Content Box */}
          <div className={message && loader_styles.card}>

              {/* The Spinning Loader Symbol */}
              <div className={loader_styles.spinner}></div>

              {/* The Main Message */}
              {message &&
                <p className={loader_styles.message}>
                  {message}{dots}
                </p>}
          </div>
      </div>
    );
};
